// blog data

export const Blogs = [
    {
        id:1,
        name:"Web Development BootCamp by Angela Yu",
        tags:["HTML","CSS","JavaScript"],
        date:"2 May, 2021",
        imgSrc:"https://images.unsplash.com/photo-1526045612212-70caf35c14df",
        link:"https://www.udemy.com/share/1013gG/"
    },
    {
        id:2,
        name:"React Js by Maximilian Schwarzmuller",
        tags:["react","styled-components" , "Redux"],
        date:"5 July, 2021",
        imgSrc:"https://images.unsplash.com/photo-1461749280684-dccba630e2f6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y29kaW5nfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
        link:"https://www.udemy.com/share/101Wby/"
    },
    {
        id:3,
        name:"Node Js by Zero to Mastery",
        tags:["NOde","Express","MiddleWare","scoket.io"],
        date:"6 march, 2022",
        imgSrc:"https://images.unsplash.com/photo-1627398242454-45a1465c2479?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bm9kZS5qc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
        link:"https://www.udemy.com/share/105EVs/"
    },
    {
        id:4,
        name:"Campous Ambassdor Internship at Ambiverse",
        tags:["Team work","Guidance","LeaderShip"],
        date:"26 May, 2022",
        imgSrc:"https://images.unsplash.com/photo-1677594332295-affd04f83115?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Y2FtcHVzJTIwYW1iYXNkb3J8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60",
        link:"https://drive.google.com/file/d/1QoXWCWzSen5R-0OrMA1bI9_GgIvAHbYT/view?usp=drivesdk"
    },
    {
        id:5,
        name:"aws SUMMIT by AWS",
        tags:["AWS"],
        date:"3  april, 2023",
        imgSrc:"https://cdn-media-1.freecodecamp.org/images/xlfWsGolEVAFQhsr3Ew2NSensVavcJPZd9Oc",
        link:"https://drive.google.com/file/d/1QM1UXMP0bDVUJgt_wpHGTjjV8DMEsZdq/view?usp=drivesdk"
    },
    {
        id:6,
        name:"Leadership and Team Effectiveness By NEPTEL",
        tags:["Leadership"],
        date:"5 Jan, 2023",
        imgSrc:"https://img.jagranjosh.com/imported/images/E/Articles/iit-madras-nptel-courses.jpg",
        link:"https://drive.google.com/file/d/1QFBUsckQBLwD1QWV8ZzC9wKyFWei5bxG/view?usp=drivesdk"

    },
   
    
  
] 